import React from "react";
// import { Essay } from "./Types";

export default function (props: {
    img?: string;
}) {


    const { img } = props;
    let style;
    if (!img) {
        style={
            backgroundColor: "#222"
        }
        return (null)
        
    } else {
        style={
            backgroundImage:`url(${process.env.PUBLIC_URL}/essays/img/${img})`
        }
    }
    
    return (
        <div className="EssayHero second half">
            <div className="wallpaper"
                style={style}
            >

            </div>
        </div>
    )
}
